import { useCallback, useEffect, useState } from 'react';
import { getAllInvoiceGroups } from 'src/shared/services/invoiceGroupService';

/**
 * Returnerar true om kunden har MINST EN fakturagrupp med ett Swish Återkommande-nummer (swishRecurringAccount)
 * ifyllt. Används för att visa Swish Återkommande-menyn för alla kunder som faktiskt konfigurerat det.
 * Hämtningen är gated på `enabled` (fakturamodul-behörighet) för att undvika onödiga/nekade anrop.
 */
export const useHasSwishRecurringAccount = (enabled = true): boolean => {
  const [hasSwishRecurring, setHasSwishRecurring] = useState(false);

  const fetch = useCallback(() => {
    if (!enabled) return;
    getAllInvoiceGroups(0, 500, 'name', 'asc', undefined)
      .then((res) => {
        setHasSwishRecurring((res.data.results ?? []).some((group) => !!group.swishRecurringAccount && group.swishRecurringAccount.trim() !== ''));
      })
      .catch(() => undefined);
  }, [enabled]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  return hasSwishRecurring;
};
